import { Component, OnInit } from '@angular/core';
import {   MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-paymentalreadypaid',
  templateUrl: './paymentalreadypaid.component.html',
  styleUrls: ['./paymentalreadypaid.component.css']
})
export class PaymentalreadypaidComponent implements OnInit {

  constructor( private dialogRef: MatDialogRef<PaymentalreadypaidComponent>) { }

  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close();
  }
}
